var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vx-card',{attrs:{"title":"Simple Stock Transfer Order (Stock Out)"}},[_c('div',{staticClass:"vx-input-group flex"},[_c('vs-tabs',[_c('vs-tab',{attrs:{"label":"Complete"}},[_c('tab-complete')],1),_c('vs-tab',{attrs:{"label":"Reversal"}},[_c('tab-reversal')],1)],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }